module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADoSURBVHgB5ZXLbQIxEIb/f+x7co0IJCWkA+iALSFSlK2DMhBwgA6WDkwJdMBjEVcKwB68IB4SEgjtXhDfxdKMNJbG42/4kS4SS9PGBVv143WvkeEGtf/8V4TNy5j6MLICSVT5BvjpMWECN7iDhLBRcn6uZpoQtFhL8yE0uFW/MUQJPtNlZ38RKqbyghYKR8MZyhLg8Jqw/rdI1PAHVRD7WPkrvyAsrEGjs7xbdyhBYa3itCBa6tWhJAaHSXkGOURI244++z5F44Dmg9s9vfoQhWDpJ1Z8yGAZV4B8HXNb8e94lFgsmj/bAaxHTXv4ufofAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/saomiao.png
// module id = mhVN
// module chunks = 1